<template>
    <el-tabs v-model="tabIndex" type="card" class="demo-tabs">
        <el-tab-pane v-for="(tabName, index) in tabs" :key="index" :label="tabName" :name="String(index)">
            <slot :name="index + 1"></slot>
        </el-tab-pane>
    </el-tabs>
</template>

<script setup lang="ts">
    import { ref } from 'vue'

    // Props
    const props = defineProps<{
        tabs: string[]
    }>()

    // Active tab index (as string so Element Plus matches)
    const tabIndex = ref('0')
</script>

<style lang="scss">
    .el-segmented {
        --el-segmented-padding: 5px;
    }
</style>
